import $ from 'jquery';
window.$ = $;
window.jQuery = $;
import {Modal} from 'bootstrap'
import './libs/slick.js'
import intlTelInput from "intl-tel-input";
import globalJS from './global.js'
import './validations';
import 'jquery-ui/dist/jquery-ui.min.js'


function getPropertyFilterUrl() {
    let url = $('.property-filters').data('url');
    return url;
}

$(document).ready(function() {

    // let url = getPropertyFilterUrl();
    // console.log(url);
    // getProperties(url);

    let niceSelectLis = $('div.nice-select').find('li');
    let options = $('select.nice-select').find('option');
    $.each(options, (i, v) => {
        // console.log($(v).data('sort-by'));
        $(niceSelectLis[i]).attr('data-sort-by', $(v).data('sort-by'));
        $(niceSelectLis[i]).attr('data-sort-order', $(v).data('sort-order'));
    });
});

function handleSorting(target) {
    let option = target;

    let sortBy = option.data('sort-by');
    let sortOrder = option.data('sort-order');

    let url = window.location.href;

    if (sortBy) {
        url = globalJS.updateQueryParam(url, 'sortBy', sortBy);
    }

    if (sortOrder) {
        url = globalJS.updateQueryParam(url, 'sortOrder', sortOrder);
    }

    window.location.href = url;
}

$(document).on('click', 'div.nice-select li', function() {
    handleSorting($(this));
});

$(document).on('change', 'select.nice-select', function() {
    handleSorting($(this).find('option:selected'));
});

$(document).ready(function() {
    $(window).scroll(function() {
        // console.log($(this).scrollTop());

        if ($(this).scrollTop() > 256) {
            // console.log($('.header-container.isMobile').length);
            $('.header-container.listing').addClass('hide');
            $('#prop-type-view-row').addClass('fixed-top');
        } else {
            $('.header-container.listing').removeClass('hide');
            $('#prop-type-view-row').removeClass('fixed-top');
        }
    });
});

$('.property-filters li input[type="checkbox"]').on('change', function() {
    let url = getPropertyFilterUrl();
    getProperties(url);
});

function getProperties(url) {
    let filters = getSelectedFilters();
    $.ajax({
        url: url, // Replace with your server endpoint
        type: 'POST',
        data: filters,
        success: function(response) {
            // Handle success
            $('.properties-container').html(response);
        },
        error: function(xhr, status, error) {
            // Handle error
            console.error('Error submitting filters:', error);
        }
    });
}

function getSelectedFilters() {
    var filterData = {
        'builds': $('input[name="builds[]"]:checked').map(function() { return this.value; }).get(),
        'amenities': $('input[name="amenities[]"]:checked').map(function() { return this.value; }).get(),
        'budget_in': $('input[name="budget_in[]"]:checked').map(function() { return this.value; }).get(),
        'budget_more_than': $('input[name="budget_more_than"]:checked').val(),
        'beds': $('input[name="beds[]"]:checked').map(function() { return this.value; }).get(),
        'baths': $('input[name="baths[]"]:checked').map(function() { return this.value; }).get()
        // Add other filters as needed
    };
    // console.log(filterData);
    return filterData;
}
